export default __webpack_public_path__ + "static/media/coin l2r.b27a9406.svg";